module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/ant-star4.44d096cd.png";